import UseFetchGetOrganizationDetails from "./UseFetchGetOrganizationDetails";

const useOrgName = () => {
  const { data } = UseFetchGetOrganizationDetails();
  return data?.payload?.name || "";
};

export default useOrgName;
